import React from 'react';
import PropTypes from 'prop-types';

const SoccerPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3zm11.237 14.767c-.85.956-2.426 1.678-3.335 1.984-.552-.735-1.521-2.056-2.184-2.952.128-1.661.476-5.098.54-6.64.692-.328 1.784-.727 2.944-.85a11.318 11.318 0 0 1 2.035 8.458zm-11.772.604c-1.381-1.092-3.998-3.255-5.056-4.002.196-1.075.616-3.62.829-4.848 1.546-.646 4.728-1.924 5.973-2.387.913.603 3.135 2.294 4.087 3.02-.098 1.436-.37 4.512-.468 5.935-1.062.446-4.32 1.806-5.365 2.282zM16 4.627c.56 0 1.113.043 1.657.123-.153.442-.357 1.054-.523 1.53-1.563.565-5.183 2.026-6.444 2.532-.816-.187-2.146-.485-2.987-.582A11.32 11.32 0 0 1 16 4.627zM4.75 14.322c.378.629 1.011 1.678 1.351 2.269-.267 1.138-.408 2.859-.454 4.116a11.303 11.303 0 0 1-1.02-4.703c0-.573.043-1.134.123-1.682zm1.78 7.983c-.123-2.29.234-4.606.434-5.774.79-.408 2.013-1.045 2.787-1.444 1.312 1.028 4.46 3.44 5.514 4.214 0 1.245 0 3.224.013 4.244-1.279.603-3.599 1.538-5.795 1.776a11.46 11.46 0 0 1-2.953-3.016zm4.007 3.674c1.372-.208 3.832-.675 5.357-1.652 1.67.565 3.836.637 4.766.595v1.597c-.93.552-2.96.858-4.499.858-1.984-.004-4.006-.51-5.624-1.398zm11.05.068v-1.733c0-.939 1.8-2.68 2.472-3.615 1.41-.434 2.422-.994 3.033-1.449-.875 2.94-3.649 5.383-5.505 6.797z"
    />
  );
};

SoccerPath.propTypes = {
  fill: PropTypes.string,
};

export default SoccerPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/soccer.jsx